import { useMutation } from 'react-query'
import { get } from 'framework/api/http'

interface GetTemplateByIdAndAppIdInterface {
  appId: string
  templateId: string
}

export const useGetTemplateByIdAndAppId = () => {
  const mutate = useMutation(({appId, templateId}: GetTemplateByIdAndAppIdInterface) => {
    return get(`/template-api/gettemplatebyId/${appId}/${templateId}`)
  })

  return mutate
}

export default useGetTemplateByIdAndAppId
